module.exports = "<div class=q-marg-all-xl> <div class=ship-docs-file-uploader-body> </div> <div class=\"q-marg-top-xl upload-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error uploading files </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/html/uploadShippingDocsModalBody.html
// module id = 1387
// module chunks = 1